import { BonusLevelGenqlSelection } from "@/gql/gen";

export const BonusLevelFields: BonusLevelGenqlSelection = {
    ID: true,
    NAME: true,
    ACTIVE: true,
    PROPERTIES: {
        ACCUMULATION_PERCENT: true,
        MAX_USE_PERCENT: true,
        ORDERS_SUMM: true,
        COLOR: true
    },
    SORT: true,
}
